import React from "react";
import { MockupDashboard } from "./mockups/MockupDashboard";

export function Hero() {
	return (
		<section className="relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-32">
			{/* Animated grid background */}
			<div className="pointer-events-none absolute inset-0">
				<div
					className="absolute inset-0 animate-grid-fade"
					style={{
						backgroundImage:
							"linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
						backgroundSize: "64px 64px",
					}}
				/>
				{/* Red accent glow */}
				<div
					className="absolute left-1/2 top-1/3 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 animate-glow-pulse rounded-full"
					style={{
						background:
							"radial-gradient(circle, rgba(219,36,30,0.12) 0%, transparent 70%)",
					}}
				/>
			</div>

			<div className="relative mx-auto max-w-7xl px-6">
				<div className="text-center">
					{/* Badge */}
					<div className="animate-fade-up mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-zinc-400">
						<ChromeIcon />
						Chrome Extension
					</div>

					{/* Headline */}
					<h1 className="animate-fade-up-delay-1 mx-auto max-w-4xl text-4xl font-bold leading-tight tracking-tight text-white md:text-6xl md:leading-tight">
						Your deals,{" "}
						<span style={{ background: "linear-gradient(135deg, #db241e 0%, #ff6b5e 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>organized.</span>
					</h1>

					{/* Subheadline */}
					<p className="animate-fade-up-delay-2 mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-400 md:text-xl">
						The comp organizer built for real estate professionals. Save what you browse, analyze deals, and collaborate with your team — all from your browser.
					</p>

					{/* CTAs */}
					<div className="animate-fade-up-delay-3 mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
						<a
							href="/signup"
							className="inline-flex items-center gap-2 rounded-lg bg-[#db241e] px-8 py-3.5 text-sm font-semibold text-white transition-all hover:bg-[#c41f1a] hover:shadow-lg hover:shadow-red-900/30"
						>
							Start 14-Day Free Trial
						</a>
						<a
							href="#features"
							onClick={(e) => {
								e.preventDefault();
								document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" });
							}}
							className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/5 px-6 py-3 text-sm font-medium text-zinc-300 transition-all hover:border-white/20 hover:bg-white/10"
						>
							See How It Works
							<svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
								<path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
							</svg>
						</a>
					</div>

					<p className="animate-fade-up-delay-3 mt-4 text-sm text-zinc-600">
						Free to start · No credit card required · $9/mo after trial
					</p>
				</div>

				{/* Mockup */}
				<div className="animate-fade-up-delay-3 mt-16 md:mt-20">
					<MockupDashboard />
				</div>
			</div>
		</section>
	);
}

function ChromeIcon() {
	return (
		<svg className="h-4 w-4" viewBox="0 0 24 24" fill="none">
			<circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
			<circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
			<path d="M21.17 8H12" stroke="currentColor" strokeWidth="1.5" />
			<path d="M7.41 2.83L12 12" stroke="currentColor" strokeWidth="1.5" />
			<path d="M7.41 21.17L12 12" stroke="currentColor" strokeWidth="1.5" />
		</svg>
	);
}
